import { isValidPhoneNumber } from 'react-phone-number-input';

const Phone = {
  isValidPhoneNumber,
};

export default Phone;
